<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"> </p>
<p class="p4">The splendor falls on castle walls <span class="s1"> <br/><br/></span>And snowy summits old in story: <span class="s1"> <br/><br/></span>The long light shakes across the lakes, <span class="s1"> <br/><br/></span>And the wild cataract leaps in glory. <span class="s1"> <br/><br/></span>Blow, bugle, blow, set the wild echoes flying, <span class="s1"> <br/><br/></span>Blow, bugle; answer, echoes, dying, dying, dying. <span class="s1"> <br/><br/></span><span class="Apple-converted-space">          </span>—Tennyson</p>
<p class="p3"><b></b> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?3021fbd2